import { useMemo } from 'react';

import { DateRange, OptionalTimeRange } from '@cast/shared-types';

import { adjustRangeForDayGranularity } from 'utils/date';

/** Matches RangePickerContext and YearPickerContext return types, so you can pass context as props directly. */
type UseDayGranularityDateRangeProps<T> = T & {
  currentDateRange: DateRange | OptionalTimeRange<string>;
  timezone: string;
  alignToHour?: boolean;
};

/**
 * Adjusts date range end to next day midnight for API compatibility with day-level granularity
 */
export const useDayGranularityDateRange = <T>({
  currentDateRange,
  timezone,
  alignToHour = true,
}: UseDayGranularityDateRangeProps<T>): DateRange => {
  const adjustedDateRange = useMemo(
    () => adjustRangeForDayGranularity(currentDateRange, timezone, alignToHour),
    [currentDateRange, timezone, alignToHour]
  );

  return adjustedDateRange;
};
